<template>

  <EntityManager
      heading="Доставки"
      heading-create="Нова доставка"
      heading-modify="Редактиране на доставка"
      heading-delete="Изтриване на доставка"
      message-delete="Избраната доставка ще бъде изтрита. Сигурни ли сте?"
      resource="/delivery"
      >
    <template #table>
      <Column field="number" header="Номер" style="flex: 0 0 10em" bodyClass="right"></Column>
      <Column field="date" header="Дата" style="flex: 0 0 10em" bodyClass="right">
        <template #body="props">
          {{new Date(props.data.date).toLocaleDateString()}}
        </template>
      </Column>
      <Column field="contragent.name" header="Контрагент">
      </Column>
      <Column field="store.name" header="Склад" footerClass="right">
        <template #footer>
          Общо:
        </template>
      </Column>
      <Column field="netto" header="Стойност" style="flex: 0 0 10em" bodyClass="right" headerClass="right" footerClass="right">
        <template #body="props">
          {{$utils.currency(props.data.netto)}}
        </template>
        <template #footer>
          {{$utils.currency(0)}}
        </template>
      </Column>
      <Column field="vat" header="ДДС" style="flex: 0 0 10em" bodyClass="right" headerClass="right" footerClass="right">
        <template #body="props">
          {{$utils.currency(props.data.vat)}}
        </template>
        <template #footer>
          {{$utils.currency(0)}}
        </template>
      </Column>
      <Column field="total" header="Общо" style="flex: 0 0 10em" bodyClass="right" headerClass="right" footerClass="right">
        <template #body="props">
          {{$utils.currency(props.data.total)}}
        </template>
        <template #footer>
          {{$utils.currency(0)}}
        </template>
      </Column>
    </template>
    <template v-slot:form="props">
      <Delivery v-model="props.entity"/>
    </template>
  </EntityManager>
<!--
  <DeliveryItem @load="onItemLoad" @save="onItemSave"
    v-model:visible="tbl.edit" v-model:data="tbl.selected" title="Доставена стока"/>
-->
</template>

<script>

export default {
  data() {
    return {
      contragents : [],
      stores : [],
      tbl: {
        selected: null,
        edit: false,
      }
    }
  },

  created() {
    //this.items = new ProductDeliveryService().getAll().data;
  },

  methods: {
    onRead(event) {
      this.tbl.selected = null;
      event.onSuccess(event.item);
      this.item = event.item;
    },
    changeDocument(document) {
      this.$emit('update:modelValue', document)
    },
    onDelete(event) {
      event.onFailure("Елементът се използва.");
      console.log(event, "Избиране на контрагент");
    },
    onSave(event) {
      event.onSuccess();
      //event.onFailure("Елементът се използва.");
    },
    total(f) {
      var total = 0;
      for(const item of this.item.items) {
        total += f(item);
      }
      return total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },
    currency(f) {
      return f.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },
    count() {
      return this.item.items.length;
    }
  }
}
</script>

<style>
</style>
